import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import { Flex } from 'components/layout/Flex';

const RmaScrapped = () => {
  const [currentLookupState] = useRecoilState(lookupState);
  const { lookupResults, selectedResult } = currentLookupState;
  const { serialNumber, product } = selectedResult || {};
  const headerCard = [
    {
      title: 'Serial #:',
      value: serialNumber,
    },
  ];

  if (!selectedResult) {
    return null;
  }

  return (
    <Flex direction="column">
      {lookupResults.length === 1 ? (
        <Header
          title="Serial Number Reported as Scrapped. Not RMA Eligible"
          subtitle={`Our records indicate that serial number ${selectedResult.serialNumber} has been scrapped. Please confirm the serial number you have provided is correct and provide the info below to submit an RMA request for this unit.`}
          cards={headerCard}
        />
      ) : null}

      <Flex spacing="space-between">
        <Flex direction="column" spacing="space-between" grow="1">
          <Product {...product} />
        </Flex>
        <WarrantyActions></WarrantyActions>
      </Flex>
    </Flex>
  );
};

export default RmaScrapped;
